export default IconArrowLoopRight2 => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-loop-right-2" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M12 21v-6m0 -6v-1a4 4 0 1 0 -4 4h13" />
  <path d="M17 16l4 -4l-4 -4" />
</svg>`;